import { CloudArrowDownIcon } from '@heroicons/react/24/outline';
import { Button } from '@mantine/core';
import { Dropzone, DropzoneProps } from '@mantine/dropzone';
import cn from 'clsx';

import styles from './select-file-input.module.scss';

type SelectFileInputProps = {
  onDrop: DropzoneProps['onDrop'];
  label?: string;
  className?: string;
  description?: string;
};

export function SelectFileInput(props: SelectFileInputProps) {
  return (
    <div className={cn(styles.container, props.className)}>
      {props.label && <p className={styles.label}>{props.label}</p>}
      <Dropzone
        onDrop={props.onDrop}
        classNames={{ root: styles.zone, inner: styles.zoneInner }}
      >
        <CloudArrowDownIcon width={24} height={24} />
        <p className={styles.zoneFirstText}>Перетащить файл</p>
        <span className={styles.zoreSecondText}>или</span>
        <Button variant="outline">Выбрать файл</Button>
      </Dropzone>
      {props.description && (
        <p className={styles.description}>{props.description}</p>
      )}
    </div>
  );
}
